import React, { useState, useEffect, useRef } from 'react';
import { Map, AdvancedMarker, Pin, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import { X, MapPin, Search, Building, Loader2, Check, AlertCircle } from 'lucide-react';

export const THAI_PROVINCES = [
  "กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พะเยา", "พังงา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยโสธร", "ยะลา", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสงคราม", "สมุทรสาคร", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อำนาจเจริญ", "อุดรธานี", "อุตรดิตถ์", "อุทัยธานี", "อุบลราชธานี"
];

export const PROVINCE_TO_REGION = {
  // ภาคกลาง
  "กรุงเทพมหานคร": "ภาคกลาง", "นนทบุรี": "ภาคกลาง", "ปทุมธานี": "ภาคกลาง", "สมุทรปราการ": "ภาคกลาง",
  "สมุทรสาคร": "ภาคกลาง", "สมุทรสงคราม": "ภาคกลาง", "นครปฐม": "ภาคกลาง", "พระนครศรีอยุธยา": "ภาคกลาง",
  "อ่างทอง": "ภาคกลาง", "ลพบุรี": "ภาคกลาง", "สิงห์บุรี": "ภาคกลาง", "ชัยนาท": "ภาคกลาง",
  "สระบุรี": "ภาคกลาง", "นครนายก": "ภาคกลาง", "สุพรรณบุรี": "ภาคกลาง",
  // ภาคตะวันออก
  "ชลบุรี": "ภาคตะวันออก", "ระยอง": "ภาคตะวันออก", "จันทบุรี": "ภาคตะวันออก", "ตราด": "ภาคตะวันออก",
  "ฉะเชิงเทรา": "ภาคตะวันออก", "ปราจีนบุรี": "ภาคตะวันออก", "สระแก้ว": "ภาคตะวันออก",
  // ภาคเหนือ
  "เชียงใหม่": "ภาคเหนือ", "เชียงราย": "ภาคเหนือ", "ลำปาง": "ภาคเหนือ", "ลำพูน": "ภาคเหนือ",
  "แม่ฮ่องสอน": "ภาคเหนือ", "น่าน": "ภาคเหนือ", "พะเยา": "ภาคเหนือ", "แพร่": "ภาคเหนือ",
  "อุตรดิตถ์": "ภาคเหนือ", "ตาก": "ภาคเหนือ", "สุโขทัย": "ภาคเหนือ", "พิษณุโลก": "ภาคเหนือ",
  "พิจิตร": "ภาคเหนือ", "กำแพงเพชร": "ภาคเหนือ", "เพชรบูรณ์": "ภาคเหนือ", "นครสวรรค์": "ภาคเหนือ",
  "อุทัยธานี": "ภาคเหนือ",
  // ภาคตะวันออกเฉียงเหนือ
  "นครราชสีมา": "ภาคตะวันออกเฉียงเหนือ", "บุรีรัมย์": "ภาคตะวันออกเฉียงเหนือ", "สุรินทร์": "ภาคตะวันออกเฉียงเหนือ",
  "ศรีสะเกษ": "ภาคตะวันออกเฉียงเหนือ", "อุบลราชธานี": "ภาคตะวันออกเฉียงเหนือ", "ยโสธร": "ภาคตะวันออกเฉียงเหนือ",
  "ชัยภูมิ": "ภาคตะวันออกเฉียงเหนือ", "อำนาจเจริญ": "ภาคตะวันออกเฉียงเหนือ", "บึงกาฬ": "ภาคตะวันออกเฉียงเหนือ",
  "หนองบัวลำภู": "ภาคตะวันออกเฉียงเหนือ", "ขอนแก่น": "ภาคตะวันออกเฉียงเหนือ", "อุดรธานี": "ภาคตะวันออกเฉียงเหนือ",
  "เลย": "ภาคตะวันออกเฉียงเหนือ", "หนองคาย": "ภาคตะวันออกเฉียงเหนือ", "มหาสารคาม": "ภาคตะวันออกเฉียงเหนือ",
  "ร้อยเอ็ด": "ภาคตะวันออกเฉียงเหนือ", "กาฬสินธุ์": "ภาคตะวันออกเฉียงเหนือ", "สกลนคร": "ภาคตะวันออกเฉียงเหนือ",
  "นครพนม": "ภาคตะวันออกเฉียงเหนือ", "มุกดาหาร": "ภาคตะวันออกเฉียงเหนือ",
  // ภาคใต้
  "ภูเก็ต": "ภาคใต้", "สุราษฎร์ธานี": "ภาคใต้", "นครศรีธรรมราช": "ภาคใต้", "สงขลา": "ภาคใต้",
  "กระบี่": "ภาคใต้", "พังงา": "ภาคใต้", "ตรัง": "ภาคใต้", "พัทลุง": "ภาคใต้", "ชุมพร": "ภาคใต้",
  "ระนอง": "ภาคใต้", "สตูล": "ภาคใต้", "ปัตตานี": "ภาคใต้", "ยะลา": "ภาคใต้", "นราธิวาส": "ภาคใต้",
  // ภาคตะวันตก
  "กาญจนบุรี": "ภาคตะวันตก", "ราชบุรี": "ภาคตะวันตก", "เพชรบุรี": "ภาคตะวันตก", "ประจวบคีรีขันธ์": "ภาคตะวันตก"
};

function MapCenterController({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    if (map && center) {
      map.panTo(center);
      if (zoom) map.setZoom(zoom);
    }
  }, [map, center, zoom]);
  return null;
}

export default function LocationPickerModal({ lead, isOpen, onClose, onLocationSaved }) {
  const [pinLocation, setPinLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 13.7563, lng: 100.5018 }); // Bangkok default
  const [zoom, setZoom] = useState(11);
  const [address, setAddress] = useState('');
  const [province, setProvince] = useState('');
  const [region, setRegion] = useState('ภาคกลาง');
  const [isSaving, setIsSaving] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const placesLibrary = useMapsLibrary('places');
  const searchInputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // Initialize state when lead changes or modal opens
  useEffect(() => {
    if (isOpen && lead) {
      const hasCoords = lead.lat && lead.lng && !isNaN(parseFloat(lead.lat)) && !isNaN(parseFloat(lead.lng));
      if (hasCoords) {
        const coords = { lat: parseFloat(lead.lat), lng: parseFloat(lead.lng) };
        setPinLocation(coords);
        setMapCenter(coords);
        setZoom(16);
      } else {
        setPinLocation(null);
        setMapCenter({ lat: 13.7563, lng: 100.5018 });
        setZoom(10);
      }

      setAddress(lead.address || '');
      setProvince(lead.province || '');
      setRegion(lead.region || (lead.province && PROVINCE_TO_REGION[lead.province]) || 'ภาคกลาง');
      setErrorMsg(null);
    }
  }, [isOpen, lead]);

  // Setup Google Places Autocomplete on the search input
  useEffect(() => {
    if (!isOpen || !placesLibrary || !searchInputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address', 'address_components'],
      componentRestrictions: { country: 'th' },
    };

    const autocomplete = new placesLibrary.Autocomplete(searchInputRef.current, options);
    autocompleteRef.current = autocomplete;

    const listener = autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }

      const newLat = place.geometry.location.lat();
      const newLng = place.geometry.location.lng();
      const newPos = { lat: newLat, lng: newLng };

      setPinLocation(newPos);
      setMapCenter(newPos);
      setZoom(16);

      if (place.formatted_address) {
        setAddress(place.formatted_address);

        // Extract province
        let detectedProvince = '';
        for (const comp of place.address_components || []) {
          if (comp.types.includes('administrative_area_level_1')) {
            const cleanComp = comp.long_name.replace('Chang Wat ', '').replace('จ.', '').replace('จังหวัด', '').trim();
            const found = THAI_PROVINCES.find(p => p.includes(cleanComp) || cleanComp.includes(p));
            if (found) {
              detectedProvince = found;
              break;
            }
          }
        }
        if (!detectedProvince) {
          const found = THAI_PROVINCES.find(p => place.formatted_address.includes(p));
          if (found) detectedProvince = found;
        }

        if (detectedProvince) {
          setProvince(detectedProvince);
          if (PROVINCE_TO_REGION[detectedProvince]) {
            setRegion(PROVINCE_TO_REGION[detectedProvince]);
          }
        }
      }
    });

    return () => {
      if (window.google) {
        window.google.maps.event.removeListener(listener);
      }
    };
  }, [isOpen, placesLibrary]);

  const handleMapClick = (e) => {
    const latLng = e.detail?.latLng || e.latLng;
    if (!latLng) return;
    const lat = typeof latLng.lat === 'function' ? latLng.lat() : latLng.lat;
    const lng = typeof latLng.lng === 'function' ? latLng.lng() : latLng.lng;

    setPinLocation({ lat, lng });

    // Reverse Geocoding via Geocoder
    if (window.google?.maps?.Geocoder) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === 'OK' && results?.[0]) {
          const best = results[0];
          setAddress(best.formatted_address || '');

          let detectedProvince = '';
          for (const comp of best.address_components || []) {
            if (comp.types.includes('administrative_area_level_1')) {
              const cleanComp = comp.long_name.replace('Chang Wat ', '').replace('จ.', '').replace('จังหวัด', '').trim();
              const found = THAI_PROVINCES.find(p => p.includes(cleanComp) || cleanComp.includes(p));
              if (found) {
                detectedProvince = found;
                break;
              }
            }
          }
          if (!detectedProvince) {
            const found = THAI_PROVINCES.find(p => best.formatted_address.includes(p));
            if (found) detectedProvince = found;
          }

          if (detectedProvince) {
            setProvince(detectedProvince);
            if (PROVINCE_TO_REGION[detectedProvince]) {
              setRegion(PROVINCE_TO_REGION[detectedProvince]);
            }
          }
        }
      });
    }
  };

  const handleProvinceChange = (e) => {
    const val = e.target.value;
    setProvince(val);
    if (PROVINCE_TO_REGION[val]) {
      setRegion(PROVINCE_TO_REGION[val]);
    }
  };

  const handleSave = async () => {
    if (!pinLocation) {
      setErrorMsg('กรุณาคลิกเลือกตำแหน่งบนแผนที่ หรือค้นหาสถานที่ก่อนบันทึกครับ');
      return;
    }

    setIsSaving(true);
    setErrorMsg(null);

    try {
      const res = await fetch(`/api/leads/${lead.id}/location`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lat: String(pinLocation.lat),
          lng: String(pinLocation.lng),
          address: address.trim(),
          province: province.trim(),
          region: region.trim()
        })
      });

      const data = await res.json();
      if (data.status === 'success') {
        if (onLocationSaved) {
          onLocationSaved({
            ...lead,
            lat: String(pinLocation.lat),
            lng: String(pinLocation.lng),
            address: address.trim(),
            province: province.trim(),
            region: region.trim()
          });
        }
        onClose();
      } else {
        setErrorMsg(data.message || 'บันทึกตำแหน่งไม่สำเร็จ');
      }
    } catch (err) {
      setErrorMsg('เกิดข้อผิดพลาดในการเชื่อมต่อ: ' + err.message);
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen || !lead) return null;

  const leadName = lead.company_name_th || lead.company_name_en || lead.customer_name || 'ไม่ระบุชื่อบริษัท';

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.65)',
      zIndex: 2500,
      backdropFilter: 'blur(4px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '850px',
        maxHeight: '92vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: '#f8fafc',
          borderBottom: '1px solid #e2e8f0',
          padding: '1.1rem 1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.2rem' }}>
              <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#2563eb', backgroundColor: '#dbeafe', padding: '0.15rem 0.55rem', borderRadius: '6px', textTransform: 'uppercase' }}>
                Google Map Location
              </span>
              <span style={{ fontSize: '0.8rem', color: '#64748b' }}>
                Lead ID: <strong>{lead.sheet_running_no || lead.id}</strong>
              </span>
            </div>
            <h2 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 700, color: '#1e293b', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Building size={18} style={{ color: 'var(--color-primary)' }} />
              {leadName}
            </h2>
          </div>
          <button
            onClick={onClose}
            disabled={isSaving}
            style={{
              background: '#f1f5f9',
              border: 'none',
              borderRadius: '8px',
              cursor: isSaving ? 'not-allowed' : 'pointer',
              color: '#64748b',
              padding: '0.45rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          
          {/* Places Search Input */}
          <div style={{ position: 'relative' }}>
            <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
            <input
              ref={searchInputRef}
              type="text"
              placeholder="ค้นหาชื่อสถานที่, ชื่อตึก, นิคมอุตสาหกรรม, หรือถนน..."
              style={{
                width: '100%',
                padding: '0.65rem 1rem 0.65rem 2.4rem',
                borderRadius: '8px',
                border: '1.5px solid #cbd5e1',
                fontSize: '0.9rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#2563eb'}
              onBlur={(e) => e.target.style.borderColor = '#cbd5e1'}
            />
          </div>

          {/* Interactive Google Map */}
          <div style={{
            height: '340px',
            borderRadius: '12px',
            overflow: 'hidden',
            border: '1px solid #cbd5e1',
            position: 'relative'
          }}>
            <Map
              mapId="LEAD_LOCATION_PICKER_MAP"
              defaultCenter={mapCenter}
              defaultZoom={zoom}
              gestureHandling="greedy"
              disableDefaultUI={false}
              onClick={handleMapClick}
              style={{ width: '100%', height: '100%' }}
            >
              <MapCenterController center={mapCenter} zoom={zoom} />
              {pinLocation && (
                <AdvancedMarker position={pinLocation}>
                  <Pin background="#eb0a1e" borderColor="#991c1c" glyphColor="#ffffff" scale={1.2} />
                </AdvancedMarker>
              )}
            </Map>
            <div style={{
              position: 'absolute',
              bottom: '10px',
              left: '10px',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              padding: '0.35rem 0.75rem',
              borderRadius: '6px',
              fontSize: '0.75rem',
              fontWeight: 600,
              color: '#334155',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              pointerEvents: 'none'
            }}>
              💡 คลิกบนแผนที่เพื่อปักหมุด หรือค้นหาชื่อสถานที่ด้านบน
            </div>
          </div>

          {/* Coordinates & Location Fields */}
          <div style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.85rem'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
              <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#1e293b', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                <MapPin size={16} style={{ color: '#eb0a1e' }} />
                พิกัดและที่อยู่ (Location Details)
              </div>
              <div style={{ fontSize: '0.8rem', color: pinLocation ? '#059669' : '#d97706', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                {pinLocation ? (
                  <>
                    <Check size={14} /> พิกัด: {pinLocation.lat.toFixed(6)}, {pinLocation.lng.toFixed(6)}
                  </>
                ) : (
                  <>
                    <AlertCircle size={14} /> ยังไม่ได้ปักหมุด
                  </>
                )}
              </div>
            </div>

            <div>
              <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '0.3rem' }}>
                ที่อยู่ / สถานที่ (Address)
              </label>
              <textarea
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                rows={2}
                placeholder="ระบุที่อยู่, ถนน, ซอย หรือจุดสังเกต..."
                style={{
                  width: '100%',
                  padding: '0.55rem 0.75rem',
                  borderRadius: '6px',
                  border: '1px solid #cbd5e1',
                  fontSize: '0.88rem',
                  outline: 'none',
                  boxSizing: 'border-box',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '0.75rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '0.3rem' }}>
                  จังหวัด (Province)
                </label>
                <input
                  list="location-picker-provinces"
                  type="text"
                  value={province}
                  onChange={handleProvinceChange}
                  placeholder="เลือกหรือพิมพ์จังหวัด..."
                  style={{
                    width: '100%',
                    padding: '0.5rem 0.75rem',
                    borderRadius: '6px',
                    border: '1px solid #cbd5e1',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
                <datalist id="location-picker-provinces">
                  {THAI_PROVINCES.map(p => (
                    <option key={p} value={p} />
                  ))}
                </datalist>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: 600, color: '#475569', marginBottom: '0.3rem' }}>
                  ภูมิภาค (Region)
                </label>
                <select
                  value={region}
                  onChange={(e) => setRegion(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.5rem 0.75rem',
                    borderRadius: '6px',
                    border: '1px solid #cbd5e1',
                    fontSize: '0.88rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                    backgroundColor: '#fff'
                  }}
                >
                  <option value="ภาคกลาง">ภาคกลาง</option>
                  <option value="ภาคตะวันออก">ภาคตะวันออก</option>
                  <option value="ภาคเหนือ">ภาคเหนือ</option>
                  <option value="ภาคตะวันออกเฉียงเหนือ">ภาคตะวันออกเฉียงเหนือ</option>
                  <option value="ภาคใต้">ภาคใต้</option>
                  <option value="ภาคตะวันตก">ภาคตะวันตก</option>
                </select>
              </div>
            </div>

            {errorMsg && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                color: '#991b1b',
                padding: '0.5rem 0.75rem',
                borderRadius: '6px',
                fontSize: '0.82rem',
                fontWeight: 500
              }}>
                ❌ {errorMsg}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{
          backgroundColor: '#f8fafc',
          borderTop: '1px solid #e2e8f0',
          padding: '1rem 1.5rem',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0.75rem'
        }}>
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            style={{
              padding: '0.6rem 1.25rem',
              borderRadius: '8px',
              border: '1px solid #cbd5e1',
              backgroundColor: '#ffffff',
              color: '#475569',
              fontWeight: 600,
              fontSize: '0.88rem',
              cursor: isSaving ? 'not-allowed' : 'pointer'
            }}
          >
            ยกเลิก
          </button>
          <button
            type="button"
            onClick={handleSave}
            disabled={isSaving || !pinLocation}
            style={{
              padding: '0.6rem 1.5rem',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: (isSaving || !pinLocation) ? '#94a3b8' : '#eb0a1e',
              color: '#ffffff',
              fontWeight: 700,
              fontSize: '0.88rem',
              cursor: (isSaving || !pinLocation) ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.45rem',
              boxShadow: '0 2px 4px rgba(235, 10, 30, 0.2)'
            }}
          >
            {isSaving ? (
              <>
                <Loader2 size={16} className="lucide-spin" /> กำลังบันทึก...
              </>
            ) : (
              <>
                <MapPin size={16} /> บันทึกตำแหน่ง
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
